 export function initImageModal() {

document.addEventListener("DOMContentLoaded", () => {

  const thumbs = document.querySelectorAll<HTMLImageElement>("[data-modal-img]");
  const imgModal = document.getElementById("imgModal") as HTMLDivElement | null;
  const modalImage = document.getElementById("modalImage") as HTMLImageElement | null;
  const closeModal = document.getElementById("closeModal") as HTMLButtonElement | null;

  if (!imgModal || !modalImage || !closeModal) {
    console.warn("Modal elements not found");
    return;
  }

  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      modalImage.src = thumb.src;
      imgModal.classList.replace("invisible", "visible");
    });
  });

  closeModal.addEventListener("click", () => {
    imgModal.classList.replace("visible", "invisible");
  });

  imgModal.addEventListener("click", (e) => {
    if (e.target === imgModal) {
      imgModal.classList.replace("visible", "invisible");
    }
  });
});
 }